<div class="container">
  <input type="file" (change)="onFileChanged($event)" #fileInput />
  <button mat-icon-button matTooltip="Choose file">
    <mat-icon svgIcon="attach_file" (click)="fileInput.click()"></mat-icon>
  </button>
  <button *ngIf="fileName" mat-icon-button matTooltip="Remove File" (click)="clearFile()">
    <mat-icon>remove_circle</mat-icon>
  </button>
  <label>{{ fileName ? fileName : 'Attach file' }} </label>
</div>
